// src/App.js
import React from 'react';
// import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './components/Home';
import Register from './components/Register';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Cases from './components/Cases';
import Navbar from './components/Navbar';
import RegisterSuccess from './components/RegisterSuccess';
import CaseSimulation from './components/CaseSimulation';
import ContinuePayment from './components/ContinuePayment';
import CaseScores from './components/CaseScores';
import DemoCaseSimulation from './components/DemoCaseSimulation';
import DemoSelector from './components/DemoSelector';
import Guide from './components/Guide';
import Terms from './components/Terms';
import HighDemand from './components/HighDemand';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

// App.js
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import { BrowserRouter as Router} from 'react-router-dom';


// function App() {
//   return (
//     <Router>
//       <div>App component with Router is working fine.</div>
//     </Router>
//   );
// }

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cases" element={<Cases />} />
        <Route path="/register/success" element={<RegisterSuccess />} />
        <Route path="/cases/:id" element={<CaseSimulation />} />
        <Route path="/cases/:id/scores" element={<CaseScores />} />
        <Route path="/continue-payment" element={<ContinuePayment />} />
        <Route path="/demo" element={<DemoSelector />} />
        <Route path="/demo/:difficulty" element={<DemoCaseSimulation />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/terms" element={<Terms />} />
        {/* <Route path="/highDemand" element={<HighDemand />} /> */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:resetToken" element={<ResetPassword />} />
        {/* Optionally, add a catch-all route for debugging */}
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </Router>
  );
}

export default App;